import React from 'react'
import { Link } from "react-router-dom";


const Product = () => {
    return (
        <>

            <div className="we-offer"style={{marginTop:"-120px"}} >
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-12">
                            {/* Section Title Start */}
                            <div className="section-title section-title-center" >
                                <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Product Mahua Shakti Blend</h3>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: 'center', position: 'relative' }}>
                                        Mahua Shakti Mix, Specially Crafted For Connoisseurs Of Taste
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Offer Item List Start */}
                            <div className="offer-item-list">
                                {/* Offer Item Start */}
                                <div className="offer-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="offer-item-image">
                                        <figure className="image-anime">
                                            <img src="assets/img/About us_4.png" alt />
                                        </figure>
                                    </div>
                                    <div className="offer-item-content">
                                        <h3>🌿 CND Mahua Shakti Blend – 200 g Pack</h3>
                                        <p>Mahua Shakti Blend – The Natural Energy & Nutrition Formula</p>
                                        {/* <a href="contact.html" className="readmore-btn">Read More</a> */}
                                        <div className="hero-body wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                            
                                            <div className="hero-btn">
                                                <Link to="/product-details" style={{fontSize:"14px"}} className="btn-default btn-highlighted">Product View</Link>
                                            </div>
                                            <div className="hero-btn">
                                                <Link to="https://wa.me/+916262556132" style={{fontSize:"14px"}} className="btn-default btn-highlighted">Buy Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Offer Item End */}
                                {/* Offer Item Start */}
                                <div className="offer-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="offer-item-image">
                                        <figure className="image-anime">
                                            <img src="assets/img/Product_2.png" alt />
                                        </figure>
                                    </div>
                                    <div className="offer-item-content">
                                        <h3> 🌿 Mahua Shakti Family Pack – Natural Nutrition for All</h3>
                                        <p>It sounds premium, natural, and market-ready for a health food product</p>
                                        {/* <a href="contact.html" className="readmore-btn">Read More</a> */}
                                        <div className="hero-body wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>

                                            <div className="hero-btn">
                                                <Link to="/product-details" style={{fontSize:"14px"}} className="btn-default btn-highlighted">Product View</Link>
                                            </div>
                                            <div className="hero-btn">
                                                <Link to="https://wa.me/+916262556132" style={{fontSize:"14px"}} className="btn-default btn-highlighted">Buy Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Offer Item End */}
                                {/* Offer Item Start */}
                                {/* <div className="offer-item wow fadeInUp" data-wow-delay="0.4s" style={{visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp'}}>
            <div className="offer-item-image">
              <figure className="image-anime">
                <img src="assets/images/we-offer-item-image-3.jpg" alt />
              </figure>
            </div>
            <div className="offer-item-content">
              <h3>Traditional Pickles</h3>
              <p>Bold, homemade flavors crafted from age-old recipes using clean ingredients</p>
              <a href="contact.html" className="readmore-btn">Read More</a>
            </div>
          </div> */}
                                {/* Offer Item End */}
                                {/* Offer Item Start */}
                                {/* <div className="offer-item wow fadeInUp" data-wow-delay="0.6s" style={{visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp'}}>
            <div className="offer-item-image">
              <figure className="image-anime">
                <img src="assets/images/we-offer-item-image-4.jpg" alt />
              </figure>
            </div>
            <div className="offer-item-content">
              <h3>Herbal Beverages</h3>
              <p>Functional tea blends and wellness drinks that help boost immunity</p>
              <a href="contact.html" className="readmore-btn">Read More</a>
            </div>
          </div> */}
                                {/* Offer Item End */}
                            </div>
                            {/* Offer Item List End */}
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Product